var render = function render(){var _vm=this,_c=_vm._self._c;return _c(require(`@/components/icons/tag/${_vm.name}.svg`),_vm._b({tag:"Component",attrs:{"x":_vm.x,"y":_vm.y,"fill":_vm.fill},on:{"v-on":_vm.$listeners}},'Component',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }